export default __webpack_public_path__ + "static/media/okapplogo.a77bd78e.png";